import React, { FC } from 'react';
import { Route } from 'react-router';
import { ProductGroupOverview } from './productgroups/overview/ProductGroupOverview';
import { ProductGroupDetail } from './productgroups/detail/ProductGroupDetail';
import { SortingView } from './productgroups/sorting/SortingView';
import { useEnvironment } from '../../shared/components/EnvironmentContext';
import { ENVIRONMENT_DEMO } from '../../constants';
import { ProductSelectionProvider } from '../../shared/product-selection/ProductSelectionContext';
import { useAuthentication } from '../../app-store/authentication/useAuthentication';
import Utils from '../../shared/utils';
import { ProductGroupPartnerFallback } from './productgroups/overview/ProductGroupPartnerFallback';
import { Navigate, Routes } from 'react-router-dom';

const MerchandisingRouteSwitch: FC = () => {
    // CatMan is not available in the demo environment
    const libraryManagedProductGroupsEnabled = useEnvironment() !== ENVIRONMENT_DEMO;
    const authentication = useAuthentication();
    const inPartnerContext = Utils.isInPartnerContext(authentication);

    if (!libraryManagedProductGroupsEnabled) {
        return <Navigate to="/" replace />;
    }

    return (
        <Routes>
            <Route index element={<Navigate to="productgroups" replace />} />
            <Route path="productgroups">
                <Route index element={inPartnerContext ? <ProductGroupPartnerFallback /> : <ProductGroupOverview />} />
                <Route path=":productGroupId">
                    <Route
                        index
                        element={
                            inPartnerContext ? (
                                <Navigate to=".." replace />
                            ) : (
                                <ProductSelectionProvider>
                                    <ProductGroupDetail />
                                </ProductSelectionProvider>
                            )
                        }
                    />
                    <Route
                        path="sorting"
                        element={inPartnerContext ? <Navigate to="../.." replace /> : <SortingView />}
                    />
                </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default MerchandisingRouteSwitch;
